/**
 * RU plural form helper for narrative count strings (Phase 8.5-07 / L18N-02).
 *
 * Wraps `Intl.PluralRules('ru-RU')`. Returns `${count} ${form}` so callers
 * compose `«Добавлено N элементов»`-style strings without re-stating count.
 * Statuses stay EN per L18N-01 — they don't go through this helper.
 */

const rules = new Intl.PluralRules('ru-RU');

export interface PluralRuForms {
  one: string;
  few: string;
  many: string;
}

export const pluralRu = (count: number, forms: PluralRuForms): string => {
  const category = rules.select(count);
  const form = category === 'one' ? forms.one : category === 'few' ? forms.few : forms.many;
  return `${String(count)} ${form}`;
};
